tinymce.addI18n("cs", {
    "#": "#",
    "Accessibility": "Bez alternativn\xedho textu",
    "Accordion": "Skl\xe1da\u010dka",
    "Accordion body...": "Obsah t\u011bla skl\xe1da\u010dky...",
    "Accordion summary...": "Shrnut\xed skl\xe1da\u010dky...",
    "Action": "Akce",
    "Activity": "Aktivita",
    "Address": "Adresa",
    "Advanced": "Pokro\u010dil\xe9",
    "Align": "Zarovn\xe1n\xed",
    "Align center": "Zarovnat na st\u0159ed",
    "Align left": "Zarovnat vlevo",
    "Align right": "Zarovnat vpravo",
    "Alignment": "Zarovn\xe1n\xed",
    "Alignment {0}": "Zarovn\xe1n\xed {0}",
    "All": "V\u0161e",
    "Alternative description": "Alternativn\xed text",
    "Alternative source": "Alternativn\xed zdroj",
    "Alternative source URL": "Alternativn\xed zdrojov\xe1 URL",
    "Anchor": "Kotva",
    "Anchor...": "Kotva",
    "Anchors": "Kotvy",
    "Animals and Nature": "Zv\xed\u0159ata a p\u0159\xedroda",
    "Arrows": "\u0160ipky",
    "B": "B",
    "Background color": "Barva pozad\xed",
    "Background color {0}": "Barva pozad\xed {0}",
    "Black": "\u010cern\xe1",
    "Block": "Do bloku",
    "Block {0}": "Blok {0}",
    "Blockquote": "Citace",
    "Blocks": "Blokov\xe9 zobrazen\xed (block)",
    "Blue": "Modr\xe1",
    "Blue component": "Modr\xe1 slo\u017eka",
    "Body": "T\u011blo",
    "Bold": "Tu\u010dn\xe9",
    "Border": "\u0160\xed\u0159ka ohrani\u010den\xed",
    "Border color": "Barva ohrani\u010den\xed",
    "Border style": "Styl ohrani\u010den\xed",
    "Border width": "\u0160\xed\u0159ka ohrani\u010den\xed",
    "Bottom": "Dol\u016f",
    "Browse files": "Proch\xe1zet soubory",
    "Browse for an image": "Vybrat obr\xe1zek",
    "Browse links": "Proch\xe1zet odkazy",
    "Bullet list": "Odr\xe1\u017eky",
    "Cancel": "Zru\u0161it",
    "Caption": "Titulek",
    "Cell": "Bu\u0148ka",
    "Cell padding": "Vnit\u0159n\xed okraj bun\u011bk",
    "Cell properties": "Vlastnosti bu\u0148ky",
    "Cell spacing": "Vn\u011bj\u0161\xed okraj bun\u011bk",
    "Cell styles": "Styly bu\u0148ky",
    "Cell type": "Typ bu\u0148ky",
    "Center": "Na st\u0159ed",
    "Characters": "Znaky",
    "Characters (no spaces)": "Znaky (bez mezer)",
    "Circle": "Krou\u017eek",
    "Class": "T\u0159\xedda",
    "Clear formatting": "Vymazat form\xe1tov\xe1n\xed",
    "Close": "Zav\u0159\xedt",
    "Code": "Code (k\xf3d)",
    "Code sample...": "Uk\xe1zka k\xf3du",
    "Code view": "Zobrazit k\xf3d",
    "Color Picker": "V\xfdb\u011br barvy",
    "Color swatch": "Vzorek barvy",
    "Cols": "Sloupc\u016f",
    "Column": "Sloupec",
    "Column clipboard actions": "Akce schr\xe1nky sloupce",
    "Column group": "Skupina sloupc\u016f",
    "Column header": "Hlavi\u010dka sloupce",
    "Constrain proportions": "Zachovat proporce",
    "Copy": "Kop\xedrovat",
    "Copy column": "Kop\xedrovat sloupec",
    "Copy row": "Kop\xedrovat \u0159\xe1dek",
    "Could not find the specified string.": "Zadan\xfd \u0159et\u011bzec nebyl nalezen.",
    "Could not load emojis": "Nelze na\u010d\xedst emotikony",
    "Count": "Po\u010det",
    "Currency": "M\u011bna",
    "Current window": "Otev\u0159\xedt v nad\u0159azen\xe9 okn\u011b",
    "Custom color": "Vlastn\xed barva",
    "Custom...": "Vlastn\xed...",
    "Cut": "Vyjmout",
    "Cut column": "O\u0159\xedznout sloupec",
    "Cut row": "Vyjmout \u0159\xe1dek",
    "Dark Blue": "Tmav\u011b modr\xe1",
    "Dark Gray": "Tmav\u011b \u0161ed\xe1",
    "Dark Green": "Tmav\u011b zelen\xe1",
    "Dark Orange": "Tmav\u011b oran\u017eov\xe1",
    "Dark Purple": "Tmav\u011b fialov\xe1",
    "Dark Red": "Tmav\u011b \u010derven\xe1",
    "Dark Turquoise": "Tmav\u011b tyrkysov\xe1",
    "Dark Yellow": "Tmav\u011b \u017elut\xe1",
    "Dashed": "\u010c\xe1rkovan\xe1",
    "Date/time": "Datum a \u010das",
    "Decrease indent": "Zmen\u0161it odsazen\xed",
    "Default": "V\xfdchoz\xed",
    "Delete accordion": "Smazat skl\xe1da\u010dku",
    "Delete column": "Smazat sloupec",
    "Delete row": "Smazat \u0159\xe1dek",
    "Delete table": "Smazat tabulku",
    "Dimensions": "Rozm\u011bry",
    "Disc": "Te\u010dka",
    "Div": "Div (blok)",
    "Document": "Dokument",
    "Dotted": "Te\u010dkovan\xe1",
    "Double": "Dvojit\xe1",
    "Drop an image here": "P\u0159et\xe1hn\u011bte obr\xe1zek do tohoto um\xedst\u011bn\xed",
    "Dropped file type is not supported": "Nahr\xe1van\xfd soubor nen\xed podporov\xe1n",
    "Edit": "\xdapravy",
    "Embed": "Vlo\u017een\xfd k\xf3d",
    "Emojis": "Emotikony",
    "Emojis...": "Emotikony...",
    "Error": "Chyba",
    "Error: Form submit field collision.": "Chyba: Kolize odes\xedlac\xedho formul\xe1\u0159ov\xe9ho pole.",
    "Error: No form element found.": "Chyba: Nebyl nalezen \u017e\xe1dn\xfd prvek formul\xe1\u0159e.",
    "Extended Latin": "Roz\u0161\xed\u0159en\xe1 latinka",
    "Failed to initialize plugin: {0}": "Selhala inicializace pluginu: {0}",
    "Failed to load plugin url: {0}": "Selhalo na\u010dten\xed URL pluginu: {0}",
    "Failed to load plugin: {0} from url {1}": "Selhalo na\u010dten\xed pluginu: {0} z URL {1}",
    "Failed to upload image: {0}": "Selhalo nahr\xe1n\xed obr\xe1zku: {0}",
    "File": "Soubor",
    "Find": "Naj\xedt",
    "Find (if searchreplace plugin activated)": "Hledat (pokud je aktivn\xed plugin 'searchreplace')",
    "Find and Replace": "Naj\xedt a nahradit",
    "Find and replace...": "Naj\xedt a nahradit",
    "Find in selection": "Ozna\u010den\xfd text",
    "Find whole words only": "Pouze cel\xe1 slova",
    "Flags": "Vlajky",
    "Focus to contextual toolbar": "P\u0159ej\xedt na kontextov\xfd panel n\xe1stroj\u016f",
    "Focus to element path": "P\u0159ej\xedt na cestu prvku",
    "Focus to menubar": "P\u0159ej\xedt na panel nab\xeddek",
    "Focus to toolbar": "P\u0159ej\xedt na panel n\xe1stroj\u016f",
    "Font": "P\xedsmo",
    "Font size {0}": "Velikost p\xedsma {0}",
    "Font sizes": "Velikost p\xedsma",
    "Font {0}": "P\xedsmo {0}",
    "Fonts": "Typ p\xedsma",
    "Food and Drink": "J\xeddlo a pit\xed",
    "Footer": "Pati\u010dka",
    "Format": "Form\xe1t",
    "Format {0}": "Form\xe1t {0}",
    "Formats": "Form\xe1ty",
    "Fullscreen": "Na celou obrazovku",
    "G": "G",
    "General": "Obecn\xe9",
    "Gray": "\u0160ed\xe1",
    "Green": "Zelen\xe1",
    "Green component": "Zelen\xe1 slo\u017eka",
    "Groove": "Dr\xe1\u017ekov\xe1",
    "Handy Shortcuts": "Praktick\xe9 kl\xe1vesov\xe9 zkratky",
    "Header": "Z\xe1hlav\xed",
    "Header cell": "Bu\u0148ka z\xe1hlav\xed",
    "Heading 1": "Nadpis 1",
    "Heading 2": "Nadpis 2",
    "Heading 3": "Nadpis 3",
    "Heading 4": "Nadpis 4",
    "Heading 5": "Nadpis 5",
    "Heading 6": "Nadpis 6",
    "Headings": "Nadpisy",
    "Height": "V\xfd\u0161ka",
    "Help": "N\xe1pov\u011bda",
    "Hex color code": "Hex k\xf3d barvy",
    "Hidden": "Skryt\xfd",
    "Horizontal align": "Vodorovn\xe9 zarovn\xe1n\xed",
    "Horizontal line": "Vodorovn\xe1 \u010d\xe1ra",
    "Horizontal space": "Vodorovn\xe9 odsazen\xed",
    "ID": "ID",
    "ID should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.": "ID by m\u011blo za\u010d\xednat p\xedsmenem a n\xe1sledn\u011b obsahovat pouze p\xedsmena, \u010d\xedslice, \u010d\xe1rky, te\u010dky, st\u0159edn\xedky nebo podtr\u017e\xedtka.",
    "Image is decorative": "(dekorativn\xed obr\xe1zek bez alternativn\xedho textu)",
    "Image list": "Seznam obr\xe1zk\u016f",
    "Image title": "N\xe1zev obr\xe1zku",
    "Image...": "Obr\xe1zek",
    "ImageProxy HTTP error: Could not find Image Proxy": "Chyba ImageProxy HTTP: Nelze nalest Image Proxy",
    "ImageProxy HTTP error: Incorrect Image Proxy URL": "Chyba ImageProxy HTTP: Chybn\xe1 adresa Image Proxy",
    "ImageProxy HTTP error: Rejected request": "Chyba ImageProxy HTTP: Po\u017eadavek zam\xedtnut",
    "ImageProxy HTTP error: Unknown ImageProxy error": "Chyba ImageProxy HTTP: Nezn\xe1m\xe1 chyba",
    "Increase indent": "Zv\u011bt\u0161it odsazen\xed",
    "Inline": "\u0158\xe1dkov\xe9 zobrazen\xed (inline)",
    "Insert": "Vlo\u017eit",
    "Insert Template": "Vlo\u017eit \u0161ablonu",
    "Insert accordion": "Vlo\u017eit skl\xe1da\u010dku",
    "Insert column after": "Vlo\u017eit sloupec vpravo",
    "Insert column before": "Vlo\u017eit sloupec vlevo",
    "Insert date/time": "Vlo\u017eit datum/\u010das",
    "Insert image": "Vlo\u017eit obr\xe1zek",
    "Insert link (if link plugin activated)": "Vlo\u017eit odkaz (pokud je aktivn\xed plugin 'link')",
    "Insert row after": "Vlo\u017eit \u0159\xe1dek pod",
    "Insert row before": "Vlo\u017eit \u0159\xe1dek nad",
    "Insert table": "Vlo\u017eit tabulku",
    "Insert template...": "Vlo\u017eit \u0161ablonu",
    "Insert video": "Vlo\u017eit video",
    "Insert/Edit code sample": "Vlo\u017eit/upravit uk\xe1zku k\xf3du",
    "Insert/edit image": "Vlo\u017eit/upravit obr\xe1zek",
    "Insert/edit link": "Vlo\u017eit/upravit odkaz",
    "Insert/edit media": "Vlo\u017eit/upravit m\xe9dia",
    "Insert/edit video": "Vlo\u017eit/upravit video",
    "Inset": "Vnit\u0159n\xed",
    "Invalid hex color code: {0}": "Chybn\xfd hex k\xf3d barvy: {0}",
    "Invalid input": "Neplatn\xfd vstup",
    "Italic": "Kurz\xedva",
    "Justify": "Do bloku",
    "Keyboard Navigation": "Navigace pomoc\xed kl\xe1vesnice",
    "Language": "Jazyk",
    "Learn more...": "Zjistit v\xedce...",
    "Left": "Vlevo",
    "Left to right": "Zleva doprava",
    "Light Blue": "Sv\u011btle modr\xe1",
    "Light Gray": "Sv\u011btle \u0161ed\xe1",
    "Light Green": "Sv\u011btle zelen\xe1",
    "Light Purple": "Sv\u011btle fialov\xe1",
    "Light Red": "Sv\u011btle \u010derven\xe1",
    "Light Yellow": "Sv\u011btle \u017elut\xe1",
    "Line height": "V\xfd\u0161ka \u0159\xe1dku",
    "Link list": "Seznam odkaz\u016f",
    "Link...": "Odkaz",
    "List Properties": "Vlastnosti seznamu",
    "List properties...": "Vlastnosti seznamu...",
    "Loading emojis...": "Na\u010d\xedt\xe1n\xed emotikon...",
    "Loading...": "Nahr\xe1v\xe1n\xed...",
    "Lower Alpha": "Mal\xe1 p\xedsmena latinka",
    "Lower Greek": "Mal\xe1 p\xedsmena \u0159e\u010dtina",
    "Lower Roman": "Mal\xe9 \u0159\xedmsk\xe9 \u010d\xedslice",
    "Match case": "Rozli\u0161ovat velikost p\xedsmen",
    "Mathematical": "Matematick\xe9 symboly",
    "Media poster (Image URL)": "URL n\xe1hledu",
    "Media...": "M\xe9dia",
    "Medium Blue": "St\u0159edn\u011b modr\xe1",
    "Medium Gray": "St\u0159edn\u011b \u0161ed\xe1",
    "Medium Purple": "St\u0159edn\u011b fialov\xe1",
    "Merge cells": "Slou\u010dit bu\u0148ky",
    "Middle": "Uprost\u0159ed",
    "Midnight Blue": "P\u016flno\u010dn\xed modr\xe1",
    "More...": "Dal\u0161\xed\u2026",
    "Name": "N\xe1zev",
    "Navy Blue": "N\xe1mo\u0159nick\xe1 mod\u0159",
    "New document": "Nov\xfd dokument",
    "New window": "Otev\u0159\xedt v nov\xe9m okn\u011b",
    "Next": "N\xe1sleduj\xedc\xed",
    "No": "Ne",
    "No alignment": "Bez zarovn\xe1n\xed",
    "No color": "Bez barvy",
    "Nonbreaking space": "Pevn\xe1 mezera",
    "None": "Nevybr\xe1no",
    "Numbered list": "\u010c\xedslov\xe1n\xed",
    "OR": "NEBO",
    "Objects": "Objekty",
    "Ok": "OK",
    "Open help dialog": "Otev\u0159\xedt okno n\xe1pov\u011bdy",
    "Open link": "C\xedlov\xe9 okno URL",
    "Open link in...": "C\xedlov\xe9 okno URL",
    "Open popup menu for split buttons": "Otev\u0159ete vyskakovac\xed nab\xeddku pro rozd\u011blen\xe1 tla\u010d\xedtka",
    "Orange": "Oran\u017eov\xe1",
    "Outset": "Vn\u011bj\u0161\xed",
    "Page break": "Konec str\xe1nky",
    "Paragraph": "Odstavec",
    "Paste": "Vlo\u017eit",
    "Paste as text": "Vlo\u017eit jako \u010dist\xfd text",
    "Paste column after": "Vlo\u017eit sloupec za",
    "Paste column before": "Vlo\u017eit sloupec p\u0159ed",
    "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.": "Je zapnuto vkl\xe1d\xe1n\xed \u010dist\xe9ho textu. Dokud nebude tato volba vypnuta, bude ve\u0161ker\xfd obsah vlo\u017een jako \u010dist\xfd text.",
    "Paste or type a link": "Zadejte nebo vlo\u017ete URL odkazu",
    "Paste row after": "Vlo\u017eit \u0159\xe1dek pod",
    "Paste row before": "Vlo\u017eit \u0159\xe1dek nad",
    "Paste your embed code below:": "Vlo\u017ete k\xf3d pro vlo\u017een\xed:",
    "People": "Lid\xe9",
    "Plugins": "Pluginy",
    "Plugins installed ({0}):": "Instalovan\xe9 pluginy ({0}):",
    "Powered by {0}": "Poh\xe1n\u011bno {0}",
    "Pre": "Pre (p\u0159edform\xe1tov\xe1no)",
    "Preferences": "P\u0159edvolby",
    "Preformatted": "P\u0159edform\xe1tovan\xfd text",
    "Premium plugins:": "Pr\xe9miov\xe9 pluginy:",
    "Press the Up and Down arrow keys to resize the editor.": "Stisknut\xedm \u0161ipek nahoru a dol\u016f zm\u011bn\xedte velikost editoru.",
    "Press the arrow keys to resize the editor.": "Stisknut\xedm kl\xe1ves se \u0161ipkami zm\u011bn\xedte velikost editoru.",
    "Press {0} for help": "Stiskn\u011bte {0} pro n\xe1pov\u011bdu",
    "Preview": "N\xe1hled",
    "Previous": "P\u0159edchoz\xed",
    "Print": "Tisk",
    "Print...": "Tisk...",
    "Purple": "Fialov\xe1",
    "Quotations": "Citace",
    "R": "R",
    "Range 0 to 255": "Rozsah 0 a\u017e 255",
    "Red": "\u010cerven\xe1",
    "Red component": "\u010cerven\xe1 slo\u017eka",
    "Redo": "Znovu",
    "Remove": "Odebrat",
    "Remove color": "Odebrat barvu",
    "Remove link": "Odstranit odkaz",
    "Replace": "Nahradit",
    "Replace all": "Nahradit v\u0161e",
    "Replace with": "Nahradit za",
    "Resize": "Zm\u011bnit velikost",
    "Restore last draft": "Obnovit posledn\xed koncept",
    "Reveal or hide additional toolbar items": "Zobrazen\xed nebo skryt\xed dal\u0161\xedch polo\u017eek panelu n\xe1stroj\u016f",
    "Rich Text Area": "Oblast pln\xe9ho textu",
    "Rich Text Area. Press ALT-0 for help.": "Oblast Rich Text, stiskn\u011bte ALT-0 pro n\xe1pov\u011bdu.",
    "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help": "Editor. Stiskn\u011bte ALT-F9 pro menu, ALT-F10 pro n\xe1strojovou li\u0161tu a ALT-0 pro n\xe1pov\u011bdu.",
    "Ridge": "H\u0159ebenov\xe1",
    "Right": "Vpravo",
    "Right to left": "Zprava doleva",
    "Row": "\u0158\xe1dek",
    "Row clipboard actions": "Akce schr\xe1nky \u0159\xe1dku",
    "Row group": "Skupina \u0159\xe1dk\u016f",
    "Row header": "Hlavi\u010dka \u0159\xe1dku",
    "Row properties": "Vlastnosti \u0159\xe1dku",
    "Row type": "Typ \u0159\xe1dku",
    "Rows": "\u0158\xe1dek",
    "Save": "Ulo\u017eit",
    "Save (if save plugin activated)": "Ulo\u017eit (pokud je aktivn\xed plugin 'save')",
    "Scope": "Rozsah",
    "Search": "Hledat",
    "Select all": "Vybrat v\u0161e",
    "Select...": "Vybrat",
    "Selection": "V\xfdb\u011br",
    "Shortcut": "Zkratka",
    "Show blocks": "Zobrazit bloky",
    "Show caption": "Zobrazit titulek",
    "Show invisible characters": "Zobrazit neviditeln\xe9 znaky",
    "Size": "Velikost",
    "Solid": "Pln\xe1",
    "Source": "Zdrojov\xe1 URL",
    "Source code": "Zdrojov\xfd k\xf3d",
    "Special Character": "Speci\xe1ln\xed znaky",
    "Special character...": "Speci\xe1ln\xed znak\u2026",
    "Split cell": "Rozd\u011blit bu\u0148ky",
    "Square": "\u010ctvere\u010dek",
    "Start list at number": "Po\u010d\xe1te\u010dn\xed \u010d\xedslo seznamu",
    "Strikethrough": "P\u0159e\u0161krtnut\xe9",
    "Style": "CSS styl",
    "Subscript": "Doln\xed index",
    "Superscript": "Horn\xed index",
    "Switch to or from fullscreen mode": "P\u0159ep\xedn\xe1n\xed mezi re\u017eimem cel\xe9 obrazovky",
    "Symbols": "Symboly",
    "System Font": "Typ p\xedsma",
    "Table": "Tabulka",
    "Table caption": "Nadpis tabulky",
    "Table properties": "Vlastnosti tabulky",
    "Table styles": "Styly tabulky",
    "Template": "\u0160ablona",
    "Templates": "\u0160ablony",
    "Text": "Text",
    "Text color": "Barva p\xedsma",
    "Text color {0}": "Barva textu {0}",
    "Text to display": "Text odkazu",
    "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?": "Zadan\xe9 URL vypad\xe1 jako e-mailov\xe1 adresa. Chcete doplnit povinn\xfd prefix mailto://?",
    "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?": "Zadan\xe9 URL vypad\xe1 jako odkaz na jin\xfd web. Chcete doplnit povinn\xfd prefix http://?",
    "The URL you entered seems to be an external link. Do you want to add the required https:// prefix?": "Zadan\xe9 URL vypad\xe1 jako odkaz na jin\xfd web. Chcete doplnit povinn\xfd prefix https://?",
    "Title": "Titulek",
    "To open the popup, press Shift+Enter": "Vyskakovac\xed okno otev\u0159ete stisknut\xedm Shift+Enter",
    "Toggle accordion": "P\u0159epnout skl\xe1da\u010dku",
    "Tools": "N\xe1stroje",
    "Top": "Nahoru",
    "Travel and Places": "Cestov\xe1n\xed a m\xedsta",
    "Turquoise": "Tyrkysov\xe1",
    "Underline": "Podtr\u017een\xe9",
    "Undo": "Zp\u011bt",
    "Upload": "Nahr\xe1t",
    "Uploading image": "Nahr\xe1v\xe1n\xed obr\xe1zku",
    "Upper Alpha": "Velk\xe1 p\xedsmena latinka",
    "Upper Roman": "Velk\xe9 \u0159\xedmsk\xe9 \u010d\xedslice",
    "Url": "URL odkazu",
    "User Defined": "Definovan\xe9 u\u017eivatelem",
    "Valid": "Platn\xfd",
    "Version": "Verze",
    "Vertical align": "Svisl\xe9 zarovn\xe1n\xed",
    "Vertical space": "Svisl\xe9 odsazen\xed",
    "View": "Zobrazit",
    "Visual aids": "Vizu\xe1ln\xed pom\u016fcky",
    "Warn": "Varov\xe1n\xed",
    "White": "B\xedl\xe1",
    "Width": "\u0160\xed\u0159ka",
    "Word count": "Po\u010det slov",
    "Words": "Slova",
    "Words: {0}": "Po\u010det slov: {0}",
    "Yellow": "\u017dlut\xe1",
    "Yes": "Ano",
    "You are using {0}": "Pou\u017e\xedv\xe1te {0}",
    "You have unsaved changes are you sure you want to navigate away?": "N\u011bkter\xe9 zm\u011bny nejsou ulo\u017eeny. Jste si opravdu jisti, \u017ee chcete opustit tuto str\xe1nku?",
    "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.": "V\xe1\u0161 prohl\xed\u017ee\u010d nepodporuje p\u0159\xedm\xfd p\u0159\xedstup do schr\xe1nky. Pou\u017eijte pros\xedm kl\xe1vesov\xe9 zkratky Ctrl+X/C/V.",
    "alignment": "zarovn\xe1n\xed",
    "austral sign": "znak austral",
    "cedi sign": "znak cedi",
    "colon sign": "znak colon",
    "cruzeiro sign": "znak cruzeiro",
    "currency sign": "znak m\u011bny",
    "dollar sign": "znak dolar",
    "dong sign": "znak dong",
    "drachma sign": "znak drachma",
    "euro-currency sign": "znak eura",
    "example": "p\u0159\xedklad",
    "formatting": "form\xe1tov\xe1n\xed",
    "french franc sign": "znak francouzsk\xfdo frank",
    "german penny symbol": "znak n\u011bmeck\xfd fenik",
    "guarani sign": "znak guaran\xed",
    "history": "historie",
    "hryvnia sign": "znak h\u0159ivna",
    "indentation": "odsazen\xed",
    "indian rupee sign": "znak indick\xe1 rupie",
    "kip sign": "znak kip",
    "lira sign": "znak lira",
    "livre tournois sign": "znak tournois libra",
    "manat sign": "znak manat",
    "mill sign": "znak mill",
    "naira sign": "znak nairo",
    "new sheqel sign": "znak nov\xfd \u0161ekel",
    "nordic mark sign": "znak norsk\xe1 marka",
    "peseta sign": "znak peseto",
    "peso sign": "znak peso",
    "ruble sign": "znak rubl",
    "rupee sign": "znak rupie",
    "spesmilo sign": "znak spesmilo",
    "styles": "styly",
    "tenge sign": "znak tenge",
    "tugrik sign": "znak tugrik",
    "turkish lira sign": "znak tureck\xe1 liry",
    "won sign": "znak won",
    "yen character": "znak jen",
    "yen/yuan character variant one": "znak jenu/juanu, varianta 1",
    "yuan character": "znak juan",
    "yuan character, in hong kong and taiwan": "znak juanu v hongkongu a tchaj-wanu",
    "{0} characters": "{0} znak\u016f",
    "{0} columns, {1} rows": "{0} sloupc\u016f, {1} \u0159\xe1dk\u016f",
    "{0} words": "{0} slov"
});